var render, staticRenderFns
import script from "./TransitionExpand.vue?vue&type=script&lang=js&"
export * from "./TransitionExpand.vue?vue&type=script&lang=js&"
import style0 from "./TransitionExpand.vue?vue&type=style&index=0&id=086c0e39&prod&scoped=true&lang=css&"
import style1 from "./TransitionExpand.vue?vue&type=style&index=1&id=086c0e39&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086c0e39",
  null
  
)

export default component.exports